export default __webpack_public_path__ + "static/gaspar-34ad75cbc54ca9087eed8cb918e26059.jpeg";